import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IEntity } from '@/Module/Core/Model/DataModel';
import { getAllFAQListAction, getFAQListByTypeIdAction, getFAQTypeListAction } from '@/Module/Question/Store/Action';
import { FAQAdapter, FAQTypeListAdapter } from '@/Module/Question/Store/Adapter';

const FAQSlice = createSlice({
  name: 'faq',
  initialState: FAQAdapter.getInitialState({
    id: null as null | IEntity['id'],
    isLoading: false,
    isErrorTypeList: false,
    page: 1,
    pageRows: 10,
    total: 0,
    typeListId: 1,
    typeId: null as null | IEntity['id'],

    types: FAQTypeListAdapter.getInitialState(),
  }),
  reducers: {
    nextPage: state => {
      state.page += 1;
    },
    resetPage: state => {
      state.page = 1;
    },
    typeId: (state, { payload }: PayloadAction<IEntity['id']>) => {
      state.typeId = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAllFAQListAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAllFAQListAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getAllFAQListAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.total = payload.paginate_info?.total || 0;

        if (state.page === 1) {
          FAQAdapter.setAll(
            state,
            payload.data.data.filter(item => item.is_active),
          );
        } else {
          FAQAdapter.addMany(
            state,
            payload.data.data.filter(item => item.is_active),
          );
        }
      });

    builder
      .addCase(getFAQListByTypeIdAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getFAQListByTypeIdAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getFAQListByTypeIdAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.total = payload.paginate_info?.total || 0;
        FAQAdapter.setAll(
          state,
          payload.data.data.filter(item => item.is_active),
        );
      });

    builder
      .addCase(getFAQTypeListAction.rejected, state => {
        state.isErrorTypeList = true;
      })
      .addCase(getFAQTypeListAction.fulfilled, (state, { payload }) => {
        state.isErrorTypeList = false;
        FAQTypeListAdapter.setAll(state.types, payload.data.data);
      });
  },
});
export const { nextPage: FAQNextPageAction, typeId: FAQTypeIdAction, resetPage: FAQPageResetAction } = FAQSlice.actions;
export default FAQSlice;
